











import React, { useState, useEffect } from "react";

const PlayersList = ({ players, onStartRec, onStopRec, cameraRecords }) => {
  const [recordingUserId, setRecordingUserId] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [completedRecordings, setCompletedRecordings] = useState({});

  // Debug function to log player IDs and recorded players
  const debugPlayerIds = () => {
    console.log("Current players:", players.map(p => ({ name: p.name, userId: p.userId })));
    if (cameraRecords?.data?.data?.[0]?.players) {
      console.log("Recorded players:", cameraRecords.data.data[0].players.map(p => ({ name: p.name, _id: p._id })));
    }
  };

  // Check which players have already been recorded based on camera records
  useEffect(() => {
    // Log data for debugging
    debugPlayerIds();

    if (cameraRecords?.data?.data?.[0]?.players) {
      const recordedIds = {};

      // Get recorded player IDs from camera records
      const recordedPlayerIds = cameraRecords.data.data[0].players.map(p => p._id);
      console.log("Recorded player IDs:", recordedPlayerIds);

      // Mark players as recorded
      players.forEach(player => {
        // Check if this player's ID is in the recorded players list
        if (recordedPlayerIds.includes(player.userId)) {
          recordedIds[player.userId] = true;
        }
      });

      console.log("Marked as recorded:", recordedIds);
      setCompletedRecordings(recordedIds);
    }
  }, [cameraRecords, players]);

  // Handle starting a recording
  const handleStartRec = (userId) => {
    if (recordingUserId) return; // Don't allow starting if someone else is recording
    setRecordingUserId(userId);
    onStartRec(userId);
  };

  // Handle stopping a recording
  const handleStopRec = (userId) => {
    onStopRec(userId);
    // We'll keep recordingUserId until we get confirmation that recording is done
  };

  // Socket event handler - should be called from parent when socket receives countdown updates
  const handleCountdownUpdate = (data) => {
    if (data.userid === recordingUserId) {
      setCountdown(data.countdown);

      if (data.isDone) {
        // Mark this recording as complete
        setCompletedRecordings(prev => ({
          ...prev,
          [data.userid]: true
        }));
        setRecordingUserId(null);
        setCountdown(null);
      }
    }
  };

  // Expose the handleCountdownUpdate method to parent
  useEffect(() => {
    if (window) {
      window.handlePlayerCountdownUpdate = handleCountdownUpdate;
    }
    return () => {
      if (window) {
        delete window.handlePlayerCountdownUpdate;
      }
    };
  }, [recordingUserId]);

  return (
    <div style={{ marginTop: 16 }}>
      <h4 style={{color:"#dee2e6"}}>Players</h4>
      {recordingUserId && (
        <div style={{
          padding: "8px 12px",
          backgroundColor: "#fff3cd",
          borderRadius: 4,
          marginBottom: 10,
          border: "1px solid #ffeeba"
        }}>
          <strong>Recording in progress</strong>
          {countdown !== null && (
            <span style={{ marginLeft: 10 }}>Countdown: {countdown}</span>
          )}
        </div>
      )}
      <ul style={{
        listStyleType: "none",
        padding: 0,
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        backgroundColor: "white"
      }}>
        {players.map((player) => {
          const isRecording = recordingUserId === player.userId;
          const isRecordingCompleted = completedRecordings[player.userId] === true;
          const isOtherPlayerRecording = recordingUserId && recordingUserId !== player.userId;

          return (
            <li key={player.userId} style={{
              padding: "12px",
              borderBottom: "1px solid #f0f0f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: player.isCreator ? "#e3f2fd" : isRecording ? "#e8f5e9" : "white"
            }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: "#e0e0e0",
                  marginRight: 10,
                  backgroundImage: player.profilePic ? `url(https://pwabucket1.s3.amazonaws.com/${player.profilePic})` : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  {!player.profilePic && player.name.charAt(0)}
                </div>
                <div>
                  <div style={{ fontWeight: "bold" }}>{player.name}</div>
                  {player.isCreator && (
                    <span style={{
                      fontSize: "0.8rem",
                      backgroundColor: "#bbdefb",
                      padding: "2px 6px",
                      borderRadius: 10,
                      marginRight: 5
                    }}>
                      Creator
                    </span>
                  )}
                </div>
              </div>

              <div>
                {isRecordingCompleted ? (
                  <div style={{
                    backgroundColor: "#4caf50",
                    color: "white",
                    padding: "6px 12px",
                    borderRadius: 4,
                    fontWeight: "bold"
                  }}>
                    Recording Done
                  </div>
                ) : isRecording ? (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {countdown !== null && (
                      <span style={{
                        marginRight: 10,
                        fontWeight: "bold",
                        color: "#555"
                      }}>
                        {countdown}s
                      </span>
                    )}

                    {Number(countdown) <= 25 && (
                      <button
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: 4,
                          cursor: "pointer",
                          fontWeight: "bold"
                        }}
                        onClick={() => handleStopRec(player.userId)}
                      >
                        Stop Rec
                      </button>
                    )}

                  </div>
                ) : (
                  <div>
                    <button
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: 4,
                        cursor: "pointer",
                        fontWeight: "bold",
                        opacity: isOtherPlayerRecording ? 0.5 : 1
                      }}
                      onClick={() => handleStartRec(player.userId)}
                      disabled={isOtherPlayerRecording}
                    >
                      Start Rec
                    </button>
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PlayersList;